import React, {createContext, useEffect, useState} from 'react';
import {BrowserRouter} from 'react-router-dom'
import AppRouter from "./components/AppRouter";
import ScrollToTop from "./utils/ScrollToTop";
import i18next from "i18next";
import getLanguagePath from "./utils/getLanguagePath";
import Popup from "./components/Popup";
import PopupSlider from "./components/PopupSlider";

export const LanguageContext = createContext([]);
export const PopupContext = createContext([]);
export const PopupSliderContext = createContext([]);
export const MobileMenuContext = createContext([]);

function App() {
    const [languageContext, setLanguageContext] = useState({});
    const [popupContext, setPopupContext] = useState('');
    const [popupSliderContext, setPopupSliderContext] = useState({list: [], active: ''});
    const [mobileMenu, setMobileMenu] = useState(false);

    useEffect(() => {
        let mql = window.innerHeight > window.innerWidth ? 'portrait' : 'landscape',
            vh = document.documentElement.clientHeight * 0.01;
        document.documentElement.style.setProperty('--vh', ''+ vh +'px');
        window.addEventListener('resize', function() {
            let vh;
            if (window.innerHeight > window.innerWidth) {
                if (mql !== 'portrait') {
                    vh = document.documentElement.clientHeight * 0.01;
                    document.documentElement.style.setProperty('--vh', ''+ vh +'px');
                    mql = 'portrait';
                }
            } else {
                if (mql !== 'landscape') {
                    vh = document.documentElement.clientHeight * 0.01;
                    document.documentElement.style.setProperty('--vh', ''+ vh +'px');
                    mql = 'landscape';
                }
            }
        });
    }, []);

    useEffect(() => {
        i18next.changeLanguage(getLanguagePath());
    });

    return (
        <LanguageContext.Provider value={[languageContext, setLanguageContext]}>
            <PopupContext.Provider value={[popupContext, setPopupContext]}>
                <PopupSliderContext.Provider value={[popupSliderContext, setPopupSliderContext]}>
                    <MobileMenuContext.Provider value={[mobileMenu, setMobileMenu]}>
                        <BrowserRouter>
                            <ScrollToTop/>
                            <AppRouter/>
                            {popupContext && <Popup/>}
                            {popupSliderContext.list.length > 0 && <PopupSlider />}
                        </BrowserRouter>
                    </MobileMenuContext.Provider>
                </PopupSliderContext.Provider>
            </PopupContext.Provider>
        </LanguageContext.Provider>
    );
}

export default App;
